"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Link_1 = require("./TmsNav/Link");
const ProfileDropdown_1 = __importDefault(require("./ProfileDropdown"));
const getAppHostConfig_1 = __importDefault(require("../utils/getAppHostConfig"));
const useSession_1 = require("../hooks/useSession");
const emotion_1 = require("emotion");
const SystemStatusFlash_1 = __importDefault(require("./SystemStatusFlash"));
const { WEB_HOST_AND_PORT } = getAppHostConfig_1.default();
exports.default = () => {
    const session = useSession_1.useSession();
    if (!session.user)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SystemStatusFlash_1.default, { session: session }),
        react_1.default.createElement("section", { className: emotion_1.css({
                flexGrow: 0,
                flexShrink: 0,
                height: 40,
                display: 'flex',
                background: '#232f3e',
                alignItems: 'center',
                '& a, & b': {
                    color: '#fff',
                    padding: '0 10px',
                    lineHeight: '40px',
                    height: '100%',
                    textDecoration: 'none',
                },
            }) },
            react_1.default.createElement("h1", { className: emotion_1.css({ flexGrow: 1, padding: 0, margin: 0 }) },
                react_1.default.createElement(Link_1.Link, { to: "/web/", className: emotion_1.css({
                        background: 'url(/logo.svg)',
                        textIndent: '-1000em',
                        display: 'block',
                        backgroundPosition: 'center center',
                        backgroundSize: '30%',
                        backgroundRepeat: 'no-repeat',
                        width: 140,
                    }) }, "ATMS")),
            react_1.default.createElement(ProfileDropdown_1.default, { user: session.user, availableProfiles: session.availableProfiles, switchProfileUri: `//${WEB_HOST_AND_PORT}/web/assumeProfile?csrfToken=${session.csrfToken}&name={username}`, signOutUri: `//${WEB_HOST_AND_PORT}/web/logout/index?csrfToken=${session.csrfToken}` }))));
};
//# sourceMappingURL=ConsoleNav.js.map